import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  HStack,
  SimpleGrid,
  Card,
  Badge,
} from '@chakra-ui/react';

function Dashboard() {
  // Mock data - will be replaced with real API calls
  const quotes = [
    {
      id: '1',
      quote_number: 'Q-2025-001',
      client: "John's Bakery",
      amount: 2500,
      status: 'draft',
      created_at: '2025-09-20',
    },
    {
      id: '2',
      quote_number: 'Q-2025-002',
      client: "Sarah's Boutique",
      amount: 6500,
      status: 'sent',
      created_at: '2025-09-18',
    },
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'draft':
        return 'gray';
      case 'sent':
        return 'blue';
      case 'viewed':
        return 'purple';
      case 'accepted':
        return 'green';
      case 'rejected':
        return 'red';
      default:
        return 'gray';
    }
  };

  return (
    <Box>
      <VStack gap={8} align="stretch">
        <HStack justifyContent="space-between">
          <VStack align="start" gap={2}>
            <Heading>Welcome back!</Heading>
            <Text color="gray.600">
              Manage your quotes and track their status
            </Text>
          </VStack>
          <Button asChild colorPalette="brand">
            <RouterLink to="/quote/new">New Quote</RouterLink>
          </Button>
        </HStack>

        {/* Stats Cards */}
        <SimpleGrid columns={{ base: 1, md: 4 }} gap={6}>
          <Card.Root>
            <Card.Body>
              <VStack align="start" gap={2}>
                <Text color="gray.600" fontSize="sm">
                  Total Quotes
                </Text>
                <Heading size="2xl">24</Heading>
              </VStack>
            </Card.Body>
          </Card.Root>

          <Card.Root>
            <Card.Body>
              <VStack align="start" gap={2}>
                <Text color="gray.600" fontSize="sm">
                  Accepted
                </Text>
                <Heading size="2xl">18</Heading>
              </VStack>
            </Card.Body>
          </Card.Root>

          <Card.Root>
            <Card.Body>
              <VStack align="start" gap={2}>
                <Text color="gray.600" fontSize="sm">
                  Total Value
                </Text>
                <Heading size="2xl">$45K</Heading>
              </VStack>
            </Card.Body>
          </Card.Root>

          <Card.Root>
            <Card.Body>
              <VStack align="start" gap={2}>
                <Text color="gray.600" fontSize="sm">
                  Conversion Rate
                </Text>
                <Heading size="2xl">75%</Heading>
              </VStack>
            </Card.Body>
          </Card.Root>
        </SimpleGrid>

        {/* Recent Quotes */}
        <VStack align="start" gap={4}>
          <Heading size="lg">Recent Quotes</Heading>

          <Box w="full">
            <VStack gap={4} align="stretch">
              {quotes.map((quote) => (
                <Card.Root key={quote.id}>
                  <Card.Body>
                    <HStack justifyContent="space-between">
                      <VStack align="start" gap={2}>
                        <HStack gap={3}>
                          <Heading size="md">{quote.quote_number}</Heading>
                          <Badge colorScheme={getStatusColor(quote.status)}>
                            {quote.status}
                          </Badge>
                        </HStack>
                        <Text color="gray.600">{quote.client}</Text>
                        <Text fontSize="sm" color="gray.500">
                          Created {quote.created_at}
                        </Text>
                      </VStack>

                      <VStack align="end" gap={2}>
                        <Heading size="lg">${quote.amount}</Heading>
                        <HStack gap={2}>
                          <Button asChild size="sm" variant="outline">
                            <RouterLink to={`/quote/${quote.id}`}>View</RouterLink>
                          </Button>
                          <Button size="sm" colorScheme="brand">
                            Edit
                          </Button>
                        </HStack>
                      </VStack>
                    </HStack>
                  </Card.Body>
                </Card.Root>
              ))}
            </VStack>
          </Box>
        </VStack>
      </VStack>
    </Box>
  );
}

export default Dashboard;